import React from 'react';
import { Popper, Paper, ClickAwayListener, Fade, Typography, Box, IconButton, Icon, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { toI18nParams } from '../../../../utils';

interface IProps {
  isConnected: boolean;
  /** Installer URL from the release manifest - empty until it has been read, or if it could not be. */
  installerUrl: string;
  /** Version the manifest advertises, shown so the user can tell what they are about to install. */
  installerVersion?: string;
  /** The manifest could not be read; there is no installer to offer. */
  installerUnavailable?: boolean;
}

const DownloadPopper: React.FC<any> = (props: IProps) => {
  const { isConnected, installerUrl, installerVersion, installerUnavailable } = props;
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Popper
        key={'connection-panel'}
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        transition
        style={{ zIndex: 1 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper elevation={6}>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Box p={2} display="flex" flexDirection="column" width={450}>
                  <Typography
                    variant="body2"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: t('f-print-adapter-download-line1') }}
                  />

                  <Typography
                    variant="body2"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: t('f-print-adapter-download-line2') }}
                  />

                  <Typography
                    variant="body2"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: t('f-print-adapter-download-line3') }}
                  />

                  {installerUnavailable && (
                    <Typography variant="body2" color="error" className="!mt-2">
                      {t('f-print-adapter-download-unavailable')}
                    </Typography>
                  )}

                  <Box mt={2} display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="caption" color="textSecondary">
                      {installerVersion ? t('f-print-adapter-download-version', toI18nParams([installerVersion])) : ''}
                    </Typography>

                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<Icon>download</Icon>}
                      component="a"
                      href={installerUrl}
                      download
                      onClick={() => setOpen(false)}
                      disabled={!installerUrl}
                    >
                      {t('f-print-adapter-download-btn')}
                    </Button>
                  </Box>
                </Box>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>

      <IconButton
        onClick={() => {
          setOpen(true);
        }}
        ref={anchorRef}
        size="small"
      >
        <Icon fontSize="large" color={isConnected ? 'disabled' : 'secondary'}>
          {'download'}
        </Icon>
      </IconButton>
    </>
  );
};

export default DownloadPopper;
